import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import ActionSelect from './components/action-select/ActionSelect';
import { STUDIO_ACTIONS } from '../../constants';
import validate from '../../../../utils/validate';
import Requests from './components/requests-history/Requests';
import Fields from './components/fields/Fields';
import useFormValidation from '../../hooks/useFormValidation';
import {
  callAiStudio,
  getFreeTextVideoRatio,
  getImagesRatio,
  getVideoRatio,
} from '../../../../redux/ai-studio/aiStudioActions';
import { AI_STUDIO_ADAPTERS } from '../../../../constants';
import { selectedMediaSelector } from '../../../../redux/ai-studio/aiStudioSelectors';
import useRationOptions from '../../hooks/useRationOptions';

import scss from './ActionsBlock.module.scss';

function ActionsBlock({ style }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('studio');
  const actionFieldsValidation = useFormValidation();

  const selectedMedia = useSelector(selectedMediaSelector);
  const { getRatioOptions } = useRationOptions();

  const initialValues = {
    action: STUDIO_ACTIONS.FREE_TEXT_EDIT,

    message: '',
    attachments: [],
  };

  const handleSubmit = async (values, form) => {
    const ratioOptions = getRatioOptions({
      mediaType: selectedMedia?.mediaType,
      action: values.action,
    });

    await dispatch(
      callAiStudio({
        values,
        adapter: AI_STUDIO_ADAPTERS.ACTIV8,
        dropdownOptions: {
          ratio: ratioOptions,
        },
      }),
    );

    form.restart();
  };

  useEffect(() => {
    dispatch(getImagesRatio());
    dispatch(getVideoRatio());
    dispatch(getFreeTextVideoRatio());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      subscription={{ submitting: true, pristine: true }}
      validate={(values) => validate(values, actionFieldsValidation)}
      render={({ handleSubmit }) => (
        <form className={scss.sidebar} style={style}>
          <span className={scss.sidebarTitle}>{t('whatDoYouWantToDo')}</span>

          <ActionSelect />

          <Requests />

          <Fields onSubmit={handleSubmit} />
        </form>
      )}
    />
  );
}

export default ActionsBlock;
